import { render, staticRenderFns } from "./SendAddress.vue?vue&type=template&id=05fa1639&scoped=true&"
import script from "./SendAddress.vue?vue&type=script&lang=js&"
export * from "./SendAddress.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/sendAddress.css?vue&type=style&index=0&id=05fa1639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa1639",
  null
  
)

export default component.exports